export default function TitleSection({ formData, errors, refs, handleInputChange }) {
  return (
    <>
      <div className="mb-6">
        <label className="block mb-2 font-semibold">Title</label>
        <input
          ref={refs.Title}
          name="Title"
          value={formData.Title}
          onChange={handleInputChange}
          className="border p-3 w-full"
        />
        {errors.Title && <p className="text-red-600">{errors.Title}</p>}
      </div>

      <div className="mb-6">
        <label className="block mb-2 font-semibold">Subtitle</label>
        <input
          ref={refs.Subtitle}
          name="Subtitle"
          value={formData.Subtitle}
          onChange={handleInputChange}
          className="border p-3 w-full"
        />
      </div>

      <div className="mb-6">
        <label className="block mb-2 font-semibold">Slug</label>
        <input
          ref={refs.Slug}
          name="Slug"
          value={formData.Slug}
          onChange={handleInputChange}
          className="border p-3 w-full"
        />
        {errors.Slug && <p className="text-red-600">{errors.Slug}</p>}
      </div>
    </>
  );
}
